import React from 'react';
import { ICustomer } from '../../store/slices/customers';
import { CustomerInfo } from '../../components/CustomerInfo/CustomerInfo';
import DigitalHealthProfileTab from '../../components/UI/SelectedSalesOrder/DigitalHealthProfileTab';
import { HistoryTable } from '../../components/UI/SelectedSalesOrder/HistoryTable';

import styles from './CustomerView.module.css';
import { useTranslation } from '../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  customer: ICustomer;
  onSelectCustomer?: () => void;
};

const CustomerView: React.FC<Props> = ({ isOpen, onClose, customer, onSelectCustomer }) => {
  const { translations } = useTranslation();
  const tabs = [
    { tabName: 'customer.profile', tabIndex: 0 },
    { tabName: 'appointment.details', tabIndex: 1 },
    { tabName: 'digital.health.profile', tabIndex: 2 },
  ];
  const [selectedTabIdx, setSelectedTabIdx] = React.useState<number>(tabs[0].tabIndex);

  return (
    <div className={styles.container}>
      <div className={styles.borderBottom}>
        <div className={styles.tabsContainer}>
          {tabs.map((tab) => (
            <div
              key={tab.tabIndex}
              className={`${styles.tab} ${selectedTabIdx === tab.tabIndex ? styles.selectedTab : ''
                }`}
              onClick={() => setSelectedTabIdx(tab.tabIndex)}
            >
              {translations(tab.tabName)}
            </div>
          ))}
        </div>
        <div className={styles.customerName}>
          {customer.person_firstname} {customer.person_lastname}
        </div>
      </div>
      <div>
        {selectedTabIdx === 0 && (
          <CustomerInfo
            customer={customer}
            canUpdate
            showQRCode
            onSelectCustomer={onSelectCustomer}
            onModalClose={onClose}
          />
        )}
        {selectedTabIdx === 1 && customer.person_id && (
          <div style={{ marginTop: 20 }}>
            <HistoryTable customer_person_id={customer.person_id} pagination />
          </div>
        )}
        {selectedTabIdx === 2 && (
          <DigitalHealthProfileTab
            person_account_number={customer.person_account_number}
            person_id={customer.person_id}
            person_external_id={customer.person_external_id}
            // get_dhp_from_merchant
            hasDocuments
            customer={customer}

          />
        )}
      </div>
    </div>
  );
};

export { CustomerView };
